import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { genArrayWithId } from '@wwe-portal/utils/array';
import { FC } from 'react';

export const ListSkeleton: FC<{ num: number }> = ({ num }) => {
  return genArrayWithId(num).map((i) => {
    return (
      <Skeleton
        key={i.id}
        className="bg-back600 h-[68px] overflow-hidden rounded-lg md:h-[300px]"
      />
    );
  });
};
